import BMRecommendationRule from './BMRecommendationRule';
import ScoreRecommendationRule from './ScoreRecommendationRule';
import DiscontinueRecommendationRule from './DiscontinueRecommendationRule';
import { DISCONTINUE_RULE, SCORE_RULE } from './constants';

const bmRecommendationRuleFactory = rule => {
    const { name } = rule;
    if (name === DISCONTINUE_RULE) {
        return new DiscontinueRecommendationRule(rule);
    }
    if (name === SCORE_RULE) {
        return new ScoreRecommendationRule(rule);
    }
    return new BMRecommendationRule(rule);
};

export default bmRecommendationRuleFactory;
